import { lazy } from 'react';

import { Permission } from '@bookora/shared';
import type { RouteObject } from 'react-router-dom';

import { RequirePermission } from '@/app/require-permission';
import { RouteErrorBoundary } from '@/components/route-error-boundary';

const SessionsPage = lazy(() => import('./sessions-page'));

/**
 * Child routes for the sessions section.
 *
 * `/sessions/:sessionId` is a deep link to one treatment record — the shape a
 * reminder SMS, an audit entry or another section links to. It renders the same
 * screen as `/sessions`, with the detail drawer already open, rather than a
 * separate page: a clinician who arrives from a link and then closes the drawer
 * should land in the list, not on a dead end.
 *
 * `<RequirePermission>` is applied here rather than inherited, because the
 * section wrapper in `router.tsx` does not extend to sibling paths.
 */
export const routes: RouteObject[] = [
  {
    path: 'sessions/:sessionId',
    element: (
      <RequirePermission anyOf={[Permission.SESSION_VIEW]}>
        <SessionsPage />
      </RequirePermission>
    ),
    // A throw with no boundary of its own bubbles to Root and replaces the
    // whole application rather than the screen that broke.
    errorElement: <RouteErrorBoundary />,
  },
];
